import Vue from 'vue'
import Router from 'vue-router'

const Index = resolve => require(['@/views/index/Index.vue'], resolve)
// const QualitysIndex = resolve => require(['@/views/index/cpnts/QualitysIndex.vue'], resolve)
// const QualitysDetail = resolve => require(['@/views/index/cpnts/QualitysDetail.vue'], resolve)
const About = resolve => require(['@/views/index/cpnts/About.vue'], resolve)
const Paypal = resolve => require(['@/views/order/Paypal.vue'], resolve)
const MyAccountCom = resolve => require(['@/views/MyAccount/index.vue'], resolve)
const MyordersCom = resolve => require(['@/views/MyAccount/cpnts/Myorders.vue'], resolve)
const Refund = resolve => require(['@/views/MyAccount/cpnts/refund.vue'], resolve)
const Reviews = resolve => require(['@/views/MyAccount/cpnts/reviews.vue'], resolve)
const Rfqs = resolve => require(['@/views/MyAccount/cpnts/rfqs.vue'], resolve)
const QuestionAnswer = resolve => require(['@/views/MyAccount/cpnts/questionAnswer.vue'], resolve)
const Comments = resolve => require(['@/views/MyAccount/cpnts/comment.vue'], resolve)
const RefundDetail = resolve => require(['@/views/MyAccount/cpnts/detail'], resolve)
const ShoppingCart = resolve => require(['@/views/order/ShoppingCart.vue'], resolve)
const OrderConfirm = resolve => require(['@/views/order/OrderConfirm.vue'], resolve)
const PayOrder = resolve => require(['@/views/order/OrderConfirm2.vue'], resolve)
const PaymentResult = resolve => require(['@/views/order/PaymentResult.vue'], resolve)
const orderDetail = resolve => require(['@/views/MyAccount/cpnts/OrderDetails'], resolve)
const RecentViewed = resolve => require(['@/views/MyAccount/cpnts/RecentViewed'], resolve)
const MyInfo = resolve => require(['@/views/MyAccount/cpnts/MyInfo'], resolve)
const ShippingAdd = resolve => require(['@/views/MyAccount/cpnts/ShippingAdd'], resolve)
const facebookBack = resolve => require(['@/components/FacebookBack'], resolve)
Vue.use(Router)

// ui组件
export default new Router({
  routes: [
    {
      path: '/',
      name: '盈店精选',
      component: Index,
      redirect: '/shoppingCart',
      children: [
        // {
        //   path: '/index',
        //   name: '盈店精选',
        //   component: QualitysIndex
        // },
        // {
        //   path: '/qualitysDetail',
        //   name: '盈店精选详情',
        //   component: QualitysDetail
        // },
        {
          path: '/shoppingCart',
          name: '盈店精选-购物车',
          component: ShoppingCart
        },
        {
          path: '/orderConfirm',
          name: 'orderConfirm',
          component: OrderConfirm
        },
        {
          path: '/facebookBack',
          name: 'facebookBack',
          component: facebookBack
        },
        {
          path: '/payorder',
          name: 'payorder',
          component: PayOrder
        },
        {
          path: '/PaymentResult',
          name: 'paymentResult',
          component: PaymentResult
        },
        {
          path: '/paypal',
          name: 'paypal',
          component: Paypal
        },
        {
          path: '/comment',
          name: '我的订单',
          component: Comments
        },
        {
          path: '/refundDetail/:orderid',
          name: 'refundDetail',
          component: RefundDetail
        },
        {
          path: '/MyAccount',
          name: 'MyAccount',
          redirect: '/myorders',
          component: MyAccountCom,
          children: [
            {
              path: '/myorders',
              name: '我的订单',
              component: MyordersCom
            },
            {
              path: '/refund',
              name: '我的订单',
              component: Refund
            },
            {
              path: '/reviews',
              name: '我的订单',
              component: Reviews
            },
            {
              path: '/rfqs',
              name: '我的订单',
              component: Rfqs
            },
            {
              path: '/questionAnswer',
              name: 'QA问答',
              component: QuestionAnswer
            },
            {
              path: '/recentviewed',
              name: '浏览记录',
              component: RecentViewed,
            },
            {
              path: '/myinfo',
              name: '个人信息',
              component: MyInfo,
            },
            {
              path: '/address',
              name: '个人信息',
              component: ShippingAdd,
            },
          ]
        },
        {
          path: '/orderDetail/:orderid',
          name: '订单详情',
          component: orderDetail
        },
        {
          path: '/about',
          name: '关于我们',
          component: About
        }
      ]
    }
  ]
})
